<template>
  <div class="row" style="padding-top: 250px">
    <div class="col-12" style="text-align: center">
      <p><strong>Thank you, this popup will close automatically!</strong></p>
      <div class="flex justify-center items-center q-pa-md">
        <QSpinner size="md" color="grey-7" />
      </div>
    </div>
  </div>
</template>

<script>
import { QSpinner } from 'quasar';
import MutateGetEnvelope from '../../graphql/mutations/MutateGetEnvelope';
import MutateDocusignStatus from '../../graphql/mutations/MutateDocusignStatus';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';
export default {
  name: 'QuoteSign',
  components: { QSpinner },
  data: function () {
    return {
      docusignStatus: null
    };
  },
  mounted() {
    this.triggerGetEnvelope();
  },
  watch: {
    docusignStatus: function (newValue) {
      if (newValue == 'completed') {
        this.updateDocusignStatusAndNavigate();
      } else {
        setTimeout(() => {
          window.parent.document.getElementById('cancelButtonId').click();
        });
      }
    }
  },
  methods: {
    triggerGetEnvelope: async function () {
      return await this.$apollo
        .mutate({
          mutation: MutateGetEnvelope
        })
        .then((data) => {
          this.docusignStatus = data.data.getEnvelope.status;
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    },
    updateDocusignStatusAndNavigate: async function () {
      await this.$apollo
        .mutate({
          mutation: MutateDocusignStatus,
          variables: {
            applicationId: this.$store.getters['vehicleApplication/vehicleApplication']
              ? this.$store.getters['vehicleApplication/vehicleApplication'].applicationId
              : null,
            docusignStatus: 'completed'
          }
        })
        .then((data) => {
          window.parent.document.getElementById('nextPageButtonId').click();
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    }
  }
};
</script>
